import ja from "@/i18n/ja";
export default { ja };
